<ng-template #sheet>
  <div class="ps" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId"
    cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="ps-grabber-hit" (touchstart)="onGrabberTouchStart($event)" (touchend)="onGrabberTouchEnd($event)">
      <div class="ps-grabber" aria-hidden="true"></div>
    </div>

    <div class="ps-head">
      <h2 class="ps-title" [id]="titleId">{{ title }}</h2>
      <button *ngIf="actionLabel; else closeBtn" type="button" class="ps-action"
        [disabled]="actionDisabled" (click)="action.emit()">{{ actionLabel }}</button>
      <ng-template #closeBtn>
        <button type="button" class="ps-close" (click)="close()" aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke-linecap="round" />
          </svg>
        </button>
      </ng-template>
    </div>

    <div class="ps-body">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
